import axios from 'axios';

/*
*  This file contains all axios calls related to mergeFields operations
*/

export const getMergeFieldsDropdown = async (funnelId = 0) => {
    const { data } = await axios.get(`/app/funnel/mergeFields/${funnelId}`);

    return data.categories;
};
